var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretDownOutline1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53125 2.96971L3.71531 5.51846C3.75052 5.55952 3.79419 5.59248 3.84333 5.61508C3.89247 5.63767 3.94591 5.64937 4 5.64937C4.05409 5.64937 4.10753 5.63767 4.15667 5.61508C4.20581 5.59248 4.24948 5.55952 4.28469 5.51846L6.46875 2.96971C6.67719 2.72643 6.50437 2.35065 6.18406 2.35065H1.81531C1.495 2.35065 1.32219 2.72643 1.53125 2.96971Z",
    fill: "#6B6978"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownOutline1);
export default __webpack_public_path__ + "static/media/caret-down-outline-1.4221efe87d6a23aec5d74be58d4f513e.svg";
export { ForwardRef as ReactComponent };